import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    public email: string;
    public registrationFormData: any = null;

    constructor() {}
    setEmail(email: string) {
        this.email = email;
    }

    getEmail(): string {
        return this.email;
    }

    setForgotEmail(email: string) {
        this.email = email;
    }

    getForgotEmail(): string {
        return this.email;
    }

    setRegistrationFormData(formData: any) {
        this.registrationFormData = formData;
    }

    getRegistrationFormData(): any {
        return this.registrationFormData;
    }

    clearRegistrationFormData() {
        this.registrationFormData = null;
    }
}
